import { render, staticRenderFns } from "./FinancialCredit.vue?vue&type=template&id=60635c06&scoped=true&"
import script from "./FinancialCredit.vue?vue&type=script&lang=js&"
export * from "./FinancialCredit.vue?vue&type=script&lang=js&"
import style0 from "./FinancialCredit.vue?vue&type=style&index=0&id=60635c06&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60635c06",
  null
  
)

export default component.exports